import { ICall, ICallParticipant } from '@app-types/websocket/calls.types';
import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

export function newCall(call: ICall) {
  socket.sendJSON({
    call,
  });
}

export function callResponse(participant: ICallParticipant) {
  socket.sendJSON({
    callResponse:participant,
  });
}

export function callHistory(id: number) {
  socket.sendJSON({
    callHistory:id,
  });
}

export function allowCalls(allow: boolean) {
  socket.sendJSON({
    allowCalls:allow,
  });
}


// WEBPACK FOOTER //
// ./src/services/calls/calls.websocket.ts